import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  useLocation,
  Navigate,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import Home from "./components/Home";
import ParentLayout from "./common/layout";
//Auth Component
import UserAuthentication from "./components/Auth";

//import componet
import Employee from "./components/Employee/index";
import Timesheet from "components/Timesheet";
import TableList from "components/Timesheet/detail";
import EmployeeCreate from "components/Employee/FormInsert";
import EmployeeUpdate from "components/Employee/FormUpdate";
import ImportDonorForm from "components/Employee/ImportDonor";
import ImportEmployeeForm from "components/Employee/ImportEmployee";
import ViewProfile from "components/Employee/ViewProfile";
import GeneralSetting from "./components/setting/General";
import Leave from "components/Leave";
import OverTimeReqest from "components/Overtime";
import Payroll from "components/Payroll";
import UpdatePayroll from "components/Payroll/UpdatePayroll";
import ImportPayroll from "components/Payroll/PayrollImport";
import ViewPayroll from "components/Payroll/ViewPayroll";
import SalaryScaleRecord from "components/SalaryScaleRecord";
import CreateSalaryScaleRecord from "components/SalaryScaleRecord/FormCreate";
import PerformanceModule from "components/Performance/PerformanceModule";
import PerformanceModuleList from "components/Performance/PerformanceModule/PerformanceModuleList";
import InsertAndUpdatePerformanceModuleForm from "components/Performance/PerformanceModule/InsertAndUpdateForm";
import PIP from "components/Performance/PIP";
import PIPInsertAndUpdate from "components/Performance/PIP/InsertAndUpdateForm";
import PDD from "components/Performance/PDD";
import PDDInsertAndUpdate from "components/Performance/PDD/InsertAndUpdateForm";
import QuarterlyReview from "components/Performance/PDD/QuarterlyReview/QuarterlyReview";
import QuarterlyReviewForm from "components/Performance/PDD/QuarterlyReview/QuarterlyReviewForm";
import YearEndAppraisal from "components/Performance/PDD/YearEndAppraisal";
import YearEndAppraisalForm from "components/Performance/PDD/YearEndAppraisal/Form";

//setting
import LeaveType from "components/setting/LeaveType";
import PayrollItem from "components/setting/PayrollItem";
import OvertimeType from "components/setting/OvertimeType";
import Branch from "components/setting/Branch";
import Setting from "components/setting";
import PublicHoliday from "components/setting/PublicHoliday";
import Role from "components/setting/Roles";
import RoleCreate from "components/setting/Roles/FormInsert";
import RoleUpdate from "components/setting/Roles/FormUpdate";
import Department from "components/setting/Department";
import Team from "components/setting/Team";
import Shift from "components/setting/Shift";
import ShiftCreate from "components/setting/Shift/FormInsert";
import ShiftUpdate from "components/setting/Shift/FormUpdate";
import ApprovalSetting from "components/setting/ApprovalSetting";
import SalaryTaxRate from "components/setting/SalaryTaxRate";
import PersionFund from "components/setting/PensionFund";
import NFFS from "components/setting/NSSF";
import VisaType from "components/setting/VisaType";
import PassportType from "components/setting/PassportType";
import Nationality from "components/setting/Nationality";
import JobLevel from "components/setting/JobLevel";
import JobGrade from "components/setting/JobGrade";
import DutyStation from "components/setting/DutyStation";
import SeniorityAndSeverancePay from "components/setting/SeniorityAndSeverancePay";

import Donor from "components/Donor";
import ImportSubProject from "components/Donor/ImportSubProject";

import PayrollReport from "components/Report/Payroll";
import PayrollForBank from "components/Report/Payroll/PayrollForBank";
import PayrollForNSSF from "components/Report/Payroll/PayrollForNSSF";
import PayrollForTax from "components/Report/Payroll/PayrollForTax";
import Payrolls from "components/Report/Payroll/Payrolls";
import CostSharing from "components/Report/Payroll/CostSharing";
import MonthlyAllocationProvidentFund from "components/Report/Payroll/MonthlyAllocationProvidentFund";
import MonthlyAllocationof13thMonthSalary from "components/Report/Payroll/MonthlyAllocationof13thMonthSalary";
import MonthlyAllocationSeniorityAndSeverancePay from "components/Report/Payroll/MonthlyAllocationSeniorityAndSeverancePay";
import SeniorityPayment from "components/Report/Payroll/SeniorityPayment";
// leave reports
import LeaveReports from "components/Report/Leaves";
import EmployeeLeaveBalance from "components/Report/Leaves/EmployeeLeaveBalance";
import MonthlyLeaveStatus from "components/Report/Leaves/MonthlyLeaveStatus";
import EmployeeLeaveBookBalance from "components/Report/Leaves/ReportLeaveBookedBalance";
// overtime report
import OvertimeReport from "components/Report/Overtime";

import BackupDatabase from "components/BackupRestore";

export default function App() {
  return (
    <ConfigProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/signin" element={<UserAuthentication />} />
          <Route path="/orders/create" element={<UserAuthentication />} />
          <Route path="/orders/update/:id" element={<UserAuthentication />} />
          <Route element={<RequireAuth />}>
            <Route element={<ParentLayout />}>
              {/* home  */}
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<Home />} />
              <Route path="/donor" element={<Donor />} />
              <Route path="/donor/import-subprojects" element={<ImportSubProject />} />
              <Route path="/employees" element={<Employee />} />
              <Route path="/salary-scale-record" element={<SalaryScaleRecord />} />
              <Route path="/salary-scale-record/create/:year" element={<CreateSalaryScaleRecord />} />
              <Route path="/employees/create" element={<EmployeeCreate />} />
              <Route path="/employees/update/:id" element={<EmployeeUpdate />} />
              <Route path="/employees/import-donor" element={<ImportDonorForm />} />
              <Route path="/employees/import-employees" element={<ImportEmployeeForm />} />
              <Route path="/employees/profile/:id" element={<ViewProfile />} />
              <Route path="/timesheets" element={<Timesheet />} />
              <Route path="/timesheets/detail/:id" element={<TableList />} />
              <Route path="/performance">
                <Route path="performance-module" element={<PerformanceModule />} />
                <Route path="performance-module/list/:id" element={<PerformanceModuleList />} />
                <Route path="performance-module/create-update/:parentId/:id" element={<InsertAndUpdatePerformanceModuleForm />} />
                <Route path="pip" element={<PIP />} />
                <Route path="pip/create" element={<PIPInsertAndUpdate />} />
                <Route path="pip/update/:id" element={<PIPInsertAndUpdate />} />
                <Route path="pdd" element={<PDD />} />
                <Route path="pdd/create" element={<PDDInsertAndUpdate />} />
                <Route path="pdd/update/:id" element={<PDDInsertAndUpdate />} />
                <Route path="quarterly-review" element={<QuarterlyReview />} />
                <Route path="quarterly-review/create" element={<QuarterlyReviewForm />} />
                <Route path="quarterly-review/edit/:id" element={<QuarterlyReviewForm />} />
                <Route path="appraisal" element={<YearEndAppraisal />} />
                <Route path="appraisal/create" element={<YearEndAppraisalForm />} />
                <Route path="appraisal/edit/:id" element={<YearEndAppraisalForm />} />
              </Route>
              <Route path="/reports">
                <Route path="payroll" element={<PayrollReport />} />
                <Route path="payroll/payroll_for_bank" element={<PayrollForBank />} />
                <Route path="payroll/payroll_for_nssf" element={<PayrollForNSSF />} />
                <Route path="payroll/payroll_for_tax" element={<PayrollForTax />} />
                <Route path="payroll/payrolls" element={<Payrolls />} />
                <Route path="payroll/cost_sharing" element={<CostSharing />} />
                <Route path="payroll/monthly_allocation_provident_fund" element={< MonthlyAllocationProvidentFund />} />
                <Route path="payroll/monthly_allocation_of_13th_month_salary" element={< MonthlyAllocationof13thMonthSalary />} />
                <Route path="payroll/monthly_allocation_seniority_and_severance_pay" element={< MonthlyAllocationSeniorityAndSeverancePay />} />
                <Route path="payroll/seniority_payment" element={< SeniorityPayment />} />
                <Route path="leaves" element={<LeaveReports />} />
                <Route path="leaves/employee-leave-balance" element={<EmployeeLeaveBalance />} />
                <Route path="leaves/employee-leave-book-balance" element={<EmployeeLeaveBookBalance />} />
                <Route path="leaves/daily-leave-status" element={<MonthlyLeaveStatus />} />
                <Route path="overtime" element={<OvertimeReport />} />
              </Route>
              <Route path="/overtime-request" element={<OverTimeReqest />} />
              <Route path="/leaves" element={<Leave />} />
              <Route path="/payrolls" element={<Payroll />} />
              <Route path="/payrolls/update/:id" element={<UpdatePayroll />} />
              <Route path="/payrolls/import" element={<ImportPayroll />} />
              <Route path="/payrolls/view/:id" element={<ViewPayroll />} />

              {/* setting  */}
              <Route path="/setting" element={<Setting />}>
                <Route path="/setting/role" element={<Role />} />
                <Route path="/setting/role/create" element={<RoleCreate />} />
                <Route path="/setting/role/update/:id" element={<RoleUpdate />} />
                <Route path="/setting/shift" element={<Shift />} />
                <Route path="/setting/shift/create" element={<ShiftCreate />} />
                <Route path="/setting/shift/update/:id" element={<ShiftUpdate />} />
                <Route path="/setting/role/update/:id" element={<RoleUpdate />} />
                <Route index element={<GeneralSetting />} />
                <Route path="/setting/payroll-item" element={<PayrollItem />} />
                <Route path="/setting/overtime-type" element={<OvertimeType />} />
                <Route path="/setting/branch" element={<Branch />} />
                <Route path="/setting/team" element={<Team />} />
                <Route path="/setting/leave-type" element={<LeaveType />} />
                <Route path="/setting/public-holiday" element={<PublicHoliday />} />
                <Route path="/setting/department" element={<Department />} />
                <Route path="/setting/approval" element={<ApprovalSetting />} />
                <Route path="/setting/salary-tax-rate" element={<SalaryTaxRate />} />
                <Route path="/setting/pension-fund" element={<PersionFund />} />
                <Route path="/setting/nssf" element={<NFFS />} />
                <Route path="/setting/visa-type" element={<VisaType />} />
                <Route path="/setting/passport-type" element={<PassportType />} />
                <Route path="/setting/nationality" element={<Nationality />} />
                <Route path="/setting/job-level" element={<JobLevel />} />
                <Route path="/setting/job-grade" element={<JobGrade />} />
                <Route path="/setting/duty-station" element={<DutyStation />} />
                <Route path="/setting/seniority-severance" element={<SeniorityAndSeverancePay />} />
              </Route>

              <Route path="/backup_restore" element={<BackupDatabase />} />
            </Route>
          </Route>
        </Routes>

      </BrowserRouter>
    </ConfigProvider>
  );
}

function RequireAuth() {
  let location = useLocation();
  if (!localStorage.getItem("ACCESS_TOKEN")) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
